import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import numberSort from 'scaleflow/utils/numberSort';
import TippyDropdown from './tippy-dropdown';

export default class DropdownsMultiSelectComponent extends TippyDropdown {
  @tracked textFilter = null;

  get ComponentName() {
    return this.args.tippy ? 'Tippy' : 'empty-component';
  }

  get DropdownComponent() {
    return this.args.tippy ? 'molecules/dropdown' : 'empty-component';
  }

  get values() {
    return this.args?.values ?? [];
  }

  get trigger() {
    return this.args?.trigger ?? 'click';
  }

  get placement() {
    return this.args.placement ?? 'bottom-start';
  }

  get interactive() {
    return this.args.interactive ?? true;
  }

  get searchable() {
    return this.args?.options?.length >= 6;
  }

  get groupedOptions() {
    const list = this?.args?.options;
    let selectedList = [];
    let othersList = [];
    list.forEach((item) => {
      if ((this.values ?? []).includes(item.value)) {
        selectedList.push(item);
      } else {
        if (!this.textFilter) othersList.push(item);
        else
          item?.label
            ?.toLowerCase?.()
            .indexOf(this.textFilter?.toLowerCase?.()) >= 0 &&
            othersList.push(item);
      }
    });

    if (this.args?.sortKey) {
      selectedList.sort((a, b) =>
        numberSort(a[this.args.sortKey], b[this.args.sortKey], 'asc'),
      );
      othersList.sort((a, b) =>
        numberSort(a[this.args.sortKey], b[this.args.sortKey], 'asc'),
      );
    }
    return {
      selected: selectedList,
      others: othersList,
    };
  }

  @action
  handleSearch(text) {
    this.textFilter = text;
  }

  @action
  async handleCheckboxToggle(item, e) {
    let values = [...this.values];
    if (e.target.checked) {
      values.push(item.value);
    } else {
      values = values.filter((_item) => _item !== item.value);
    }
    this.args?.onSelect?.(values);
  }

  @action
  onShown() {
    document.querySelector('#searchable')?.focus?.();
  }

  @action
  handleClearSelection() {
    let values = [];
    this.args?.onSelect(values);
  }

  @action
  setTippyInstance(instance) {
    this.tippyInstance = instance;
  }

  @action
  focusSearch() {
    const search = document.querySelector('.inner-tippy-dropdown #searchable');
    if (search) search.focus();
  }

  willDestroy() {
    this.textFilter = null;
    super.willDestroy(...arguments);
  }
}
